import styled from 'styled-components';

export const FACELIVENESS_SESSION_TIMEOUT = 120000;

export const FULLY_VISIBLE_THRESHOLD = 1;

export const Label = styled.h5`
    font-size: 1.05rem;
    text-align: left;
    color: gray;
    padding: 0.5rem;
`;

export const StickyButton = styled.a`
  width: 2.5rem;
  height: 2.5rem;
  background-color: ${(p) => p.theme.primary};
  position: fixed;
  bottom: 1rem;
  right: 50%;
  transform: translateX(50%);
  z-index: 999;
  scroll-behavior: smooth;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: ${(p) => p.theme.light};
`;
